/** Picks v2 or v1 of the Research Data Explorer based on the redesign flag. */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import ResearchDataExplorerPage   from './ResearchDataExplorerPage';
import ResearchDataExplorerPageV2 from './v2/ResearchDataExplorerPageV2';

export default function ResearchDataExplorerPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? ResearchDataExplorerPageV2 : ResearchDataExplorerPage;
  return <Component {...props} />;
}
